import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('substancias');

export const check = () => useBasicAuth.checkToken();

export const findSubstanciaById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllSubstancia = () => 
  axios.get(urlAPI + "/findAll", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllSubstanciaByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const findAllSubstanciaByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const addSubstancia = (obj) => 
  axios.post(urlAPI + "/addSubstancia" , JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateSubstancia = (obj) => 
  axios.put(urlAPI + "/updateSubstancia/" + obj.substancia.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const deleteSubstancia = (id) => 
  axios.delete(urlAPI + "/deleteSubstancia/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });



//SUBSTANCIA_SUBSTANCIA_USO
export const findAllBySubstanciaSubstanciaUso_substancia = (substancia) => 
  axios.post(urlAPI + "/substanciasubstanciaUso/substancia", JSON.stringify(substancia), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllBySubstanciaSubstanciaUso_substanciaUso = (substanciaUso) => 
  axios.post(urlAPI + "/substanciasubstanciaUso/substanciaUso", JSON.stringify(substanciaUso), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllBySubstanciaSubstanciaUso = (substancia, substanciaUso) => {
  let requestObj = {
    substancia: substancia,
    substanciaUso: substanciaUso
  }
  axios.post(urlAPI + "/substanciasubstanciaUso", JSON.stringify(requestObj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
}